import { render } from "./LogoSelector.vue?vue&type=template&id=12a90838&scoped=true"
import script from "./LogoSelector.vue?vue&type=script&lang=js"
export * from "./LogoSelector.vue?vue&type=script&lang=js"

import "./LogoSelector.vue?vue&type=style&index=0&id=12a90838&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a90838"]])

export default __exports__